<template>
  <main class="catalog-page page">
    <div class="page__inner">
      <SectionComponent>
        <BreadcrumbsComponent :links="breadcrumbs" />
        <div class="page__inner">
          <h1>Каталог</h1>
          <div class="catalog-page__groups">
            <GroupCard v-for="(item, i) in groups" :key="i" :data="item" />
          </div>
          <div class="catalog-page__groups">
            <CategoryCard v-for="(item, i) in categories" :key="i" :data="item" />
          </div>
        </div>
      </SectionComponent>
      <ForAutoBlock :data="brands" />
      <SectionComponent>
        <div class="page__inner">
          <WrapperComponent v-if="desktop" title="Услуги">
            <div class="catalog-page__groups">
              <ServiceCard v-for="(item, i) in services" :key="i" :data="item" />
              <div @click="openModal" v-if="desktop" class="catalog-page__question">
                <span class="catalog-page__question-title">Не нашли то, что нужно?</span>
                <span class="catalog-page__question-subtitle"
                  >Мы решаем все вопросы, касающиеся автомобильной электроники и гаджетов.</span
                >
                <span class="catalog-page__question-subtitle">
                  Оставить заявку
                  <IconComponent name="arrow-right" />
                </span>
              </div>
            </div>
          </WrapperComponent>
          <SliderComponent
            v-if="mobile"
            title="Услуги"
            v-slot="{ item }"
            :items="services"
            :slider-options="servicesSliderOption"
          >
            <ServiceCard :data="item" />
          </SliderComponent>
        </div>
      </SectionComponent>
      <div @click="openModal" v-if="mobile" class="catalog-page__question">
        <span class="catalog-page__question-title">Не нашли то, что нужно?</span>
        <span class="catalog-page__question-subtitle"
          >Мы решаем все вопросы, касающиеся автомобильной электроники и гаджетов.</span
        >
        <span class="catalog-page__question-subtitle">
          Оставить заявку
          <IconComponent name="arrow-right" />
        </span>
      </div>
    </div>
  </main>
</template>

<script>
import SectionComponent from "components/SectionComponent.vue";
import GroupCard from "./components/GroupCard.vue";
import CategoryCard from "components/CategoryCard.vue";
import ForAutoBlock from "components/ForAutoBlock.vue";
import WrapperComponent from "components/WrapperComponent.vue";
import ServiceCard from "components/ServiceCard.vue";
import SliderComponent from "components/slider/SliderComponent.vue";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import IconComponent from "components/IconComponent.vue";
import CATALOG_PAGE from "@/graphql/pages/CatalogPage.graphql";
import ProductRequestModal from "components/modal/components/ProductRequestModal.vue";
export default {
  name: "CatalogPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: CATALOG_PAGE,
      })
      .then(({ data }) => {
        store.state.catalog_page.groups = data.groups;
        store.state.catalog_page.brands = data.brands;
        store.state.catalog_page.categories = data.categories;
        store.state.catalog_page.services = data.services;
      })
      .catch(() => {});
  },

  data() {
    return {
      mobile: false,
      desktop: true,
      breadcrumbs: [
        {
          title: "Каталог",
        },
      ],
      servicesSliderOption: {
        slidesPerView: 3,
        clickable: true,
        preloadImages: true,
        loop: true,
        autoHeight: true,
        initialSlide: 2,
        spaceBetween: 30,
        freeModeFluid: true,
        autoplay: {
          delay: 3000,
        },
        speed: 1000,
        breakpoints: {
          0: {
            slidesPerView: 1.2,
          },
          580: {
            slidesPerView: 1.7,
          },
          750: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 2.5,
          },
          1200: {
            slidesPerView: 3,
          },
        },
      },
    };
  },
  mounted() {
    this.screenStatus();
  },
  computed: {
    categories() {
      return this.$store.state.catalog_page.categories || [];
    },
    brands() {
      return this.$store.state.catalog_page.brands || [];
    },
    services() {
      return this.$store.state.catalog_page.services || [];
    },
    groups() {
      return this.$store.state.catalog_page.groups || [];
    },
  },
  methods: {
    screenStatus() {
      if (window.outerWidth > 1024) {
        this.desktop = true;
        this.mobile = false;
      } else {
        this.mobile = true;
        this.desktop = false;
      }
    },
    openModal() {
      this.$store.state._modals.push({
        component: ProductRequestModal,
      });
    },
  },

  components: {
    IconComponent,
    BreadcrumbsComponent,
    SliderComponent,
    ServiceCard,
    WrapperComponent,
    ForAutoBlock,
    CategoryCard,
    GroupCard,
    SectionComponent,
  },
};
</script>

<style lang="stylus">
.catalog-page {
  background: var(--white-2);

  &__groups {
    display grid
    grid-template-columns repeat(3,1fr)
    gap 30px

    +below(1024px) {
      grid-template-columns repeat(2,1fr)
    }
    +below(700px) {
      grid-template-columns repeat(1,1fr)
    }
  }

  &__question {
    display flex
    flex-direction column
    align-items: center;
    justify-content: center;
    padding 36px
    gap 20px
    background var(--main)
    box-shadow: 0 4px 43px #EAEAF2;
    border-radius: var(--main-radius);
    cursor pointer

    +below(1024px) {
      border-radius 0
    }

    &-title {
      font-weight: 500;
      font-size: 1.5em;
      line-height: 28px;
      text-align: center;
      color: var(--black);
    }

    &-subtitle {
      font-weight: 400;
      font-size: 1.25em;
      line-height: 32px;
      text-align: center;
      color: var(--black);
    }

    .icon svg {
      width: 22px;

      path {
        fill var(--black)
      }
    }
  }
}
</style>
